import { createSlice } from "@reduxjs/toolkit"

type PollingType = {
  pollingId?: number | null
}

export const initialState: PollingType = {
  pollingId: null,
}

export const pollingSlice = createSlice({
  name: "polling",
  initialState,
  reducers: {
    start: (state, { payload }) => {
      state.pollingId = payload.pollingId
    },
    reset: () => {
      return initialState
    },
  },
})

export const { start, reset } = pollingSlice.actions

export default pollingSlice.reducer
